import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import App from "./App";

import "./index.css";
import { PersistGate } from "redux-persist/integration/react";

import { ConfigProvider } from "antd";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(

    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#00b96b",
            },
          }}
        >
          <App />
        </ConfigProvider>
      </PersistGate>
    </Provider>

);
